import { requestApiUser } from "../functions";

export const PricesQueriesClient = {
    create: async (data) => {
        const res = await requestApiUser('/products/prices', 'POST', data);
        return res;
    },

    findById: async (id) => {
        const res = await requestApiUser(`/products/prices/${id}`, 'GET');
        return res;
    },

    findByProductId: async (productId) => {
        const res = await requestApiUser(`/products/prices/product/${productId}`, 'GET');
        return res;
    }
};